export default __webpack_public_path__ + "static/media/IconDesc_LiquidFuel_Pipe.256.fa4cb665.png";